import createVueComponent from '../createVueComponent';
var Zap = createVueComponent('ZapIcon', [['polygon', {
  points: '13 2 3 14 12 14 11 22 21 10 12 10 13 2',
  key: '45s27k'
}]]);
export default Zap;